import { useQuery } from '@apollo/client';
import { MattersDocument } from '~/graphql/queries/matters';
import type { MatterViewModel } from './matters.types';

export interface UseMattersQueryResult {
  matters: MatterViewModel[];
  isLoading: boolean;
  error: Error | undefined;
}

export const useMattersQuery = (): UseMattersQueryResult => {
  const { data, loading, error } = useQuery(MattersDocument);

  return {
    matters: data?.matters ?? [],
    isLoading: loading,
    error,
  };
};
